import { ref, onMounted } from 'vue';
import { config } from '@/config';

export function useRecaptcha() {
  const recaptchaContainer = ref(null);
  const recaptchaWidgetId = ref(null);
  const recaptchaError = ref(false);

  onMounted(() => {
    if (!config.siteKeyRecaptcha) return;

    const timer = setInterval(() => {
      if (window.grecaptcha?.enterprise && recaptchaContainer.value && !recaptchaWidgetId.value) {
        window.grecaptcha.enterprise.ready(() => {
          recaptchaWidgetId.value = window.grecaptcha.enterprise.render(recaptchaContainer.value, {
            sitekey: config.siteKeyRecaptcha,
          });
          clearInterval(timer);
        });
      }
    }, 300);
  });

  const getRecaptchaToken = () => {
    recaptchaError.value = false;

    if (!config.siteKeyRecaptcha) {
      return null;
    }

    let token = null;
    if (window.grecaptcha?.enterprise && recaptchaWidgetId.value !== null) {
      token = window.grecaptcha.enterprise.getResponse(recaptchaWidgetId.value);
    }

    if (!token) {
      recaptchaError.value = true;
      return null;
    }

    return token;
  };

  return {
    recaptchaContainer,
    recaptchaError,
    getRecaptchaToken,
  };
}
